export default "__VITE_ASSET__DDf9kIuk__"